import { Routes, Route, Outlet } from "react-router-dom";
import AlarmContextProvider from "../context/AlarmContextProvider";
import AlarmsDetails from "../pages/AlarmsDetails";
import AlarmsConsultComponent from "../pages/AlarmsConsultComponent";
import AlarmsConsultList from "../components/AlarmsConsultList";
import AlarmFormRegister from "../components/AlarmFormRegister";
import AlarmsList from "../pages/AlarmsList";

export default function AlarmRoutes() {
  return (
    <>
      <AlarmContextProvider>
        <Routes>
          <Route path="/matriz" element={<AlarmsConsultList />} />
          <Route path="/matriz/:code" element={<AlarmsConsultComponent />} />
          <Route path="/matriz/cadastrar" element={<AlarmFormRegister />} />
          <Route
            path="/details"
            element={<AlarmsDetails />}
          />
          <Route
            path="/:usinaName/:usinaId/:ug/:inv/:code"
            element={<AlarmsDetails />} />
          <Route />
          <Route
            path="/:usinaName/:usinaId/:code"
            element={<AlarmsList />} />
          <Route />
          <Route path="/equipment-alarms-list" element={<AlarmsList />} />
        </Routes>
        <Outlet />
      </AlarmContextProvider>
    </>
  );
}
